import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getExportColumns } from "../utils/api";

// Lazily fetch the available columns for the detailed report Excel export
export const useExportColumnsQuery = (enabled) =>
  useQuery({
    queryKey: ["detailed-report-export-columns"],
    queryFn: async () => (await getExportColumns()).data,
    enabled,
    ...reactQueryCacheAndRefetchOptions,
  });
